import useAppQuery from 'core/query-client/useAppQuery';
import { getProject } from 'shared/api/projects/http';

export const createUseProjectQueryKey = (projectId) => ['project', projectId.toString()];

const useProjectQuery = (projectId, options = undefined) =>
  useAppQuery(createUseProjectQueryKey(projectId), () => getProject(projectId), options);

export default useProjectQuery;
